import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

function DeepLinkHandler() {
  const { collectionId } = useParams();

  useEffect(() => {
    // Detect if user is on iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    if (isIOS && collectionId) {
      // Universal Links will handle this automatically if the app is installed
      // This component serves as a fallback/loading page
      
      // If Universal Links don't work (app not installed), try custom URL scheme
      const deepLinkUrl = `com.metehanoz.bookthingapp://collection/${collectionId}`;
      
      // Wait a bit to see if Universal Link worked
      setTimeout(() => {
        // Try custom URL scheme as fallback
        window.location.href = deepLinkUrl;
        
        // Optional: Fallback to App Store if app is not installed
        // Uncomment and modify with your actual App Store URL if needed
        // setTimeout(() => {
        //   window.location.href = 'https://apps.apple.com/app/your-app-id';
        // }, 2000);
      }, 500);
    } else if (collectionId) {
      // For non-iOS devices, you could redirect to a web version or show a message
      console.log('Deep linking is only supported on iOS devices');
      // You could redirect to a different page or show content here
    }
  }, [collectionId]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      padding: '20px',
      textAlign: 'center'
    }}>
      <h2>Opening in BookThing App...</h2>
      <p>If the app doesn't open automatically, please make sure you have the BookThing app installed.</p>
      <div style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
        Collection ID: {collectionId}
      </div>
    </div>
  );
}

export default DeepLinkHandler;

